import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=11163c3c&scoped=true&"
import script from "./Journals.vue?vue&type=script&lang=js&"
export * from "./Journals.vue?vue&type=script&lang=js&"
import style0 from "./Journals.vue?vue&type=style&index=0&id=11163c3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11163c3c",
  null
  
)

export default component.exports